import { useState } from "react";
import { Card, Typography, Grid, TextField, Stack, Box } from "@mui/material";
import FormCard from "./FormCard";
import SearchIcon from "@mui/icons-material/Search";
import MyTable from "../../components/Schedule/MyTable";

const FireDepartment = () => {
  const [rows, setRows] = useState([
    {
      id: 1,
      "S.No.": 1,
      Quantity: "5",
      Item: "Wheel chocks",
      "Item Description":
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
      "Parent Location": "Parent Location 1 ",
    },
    {
      id: 2,
      "S.No.": 2,
      Quantity: "2",
      Item: "Firehose",
      "Item Description":
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
      "Parent Location": "Parent Location 1 ",
    },
    {
      id: 3,
      "S.No.": 3,
      Quantity: "14",
      Item: "Medical",
      "Item Description":
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
      "Parent Location": "Parent Location 1 ",
    },
  ]);

  const selectOptions = {
    "Fire Department Name": [
      { value: "department1", label: "Department 1" },
      { value: "department2", label: "Department 2" },
      { value: "department3", label: "Department 3" },
    ],
    Station: [
      { value: "station1", label: "Station 1" },
      { value: "station2", label: "Station 2" },
      { value: "station3", label: "Station 3" },
    ],
    "Engine Bay": [
      { value: "bay1", label: "Engine Bay 1" },
      { value: "bay2", label: "Engine Bay 2" },
      { value: "bay3", label: "Engine Bay 3" },
    ],
  };

  let columns = [
    {
      field: "S.No.",
      headerName: "S. No.",
      sortable: false,
      flex: 1,
      minWidth: 50,
      filterable: false,
    },
    {
      field: "Quantity",
      headerName: "Quantity",
      sortable: false,
      flex: 1,
      minWidth: 200,
      filterable: false,
    },
    {
      field: "Item",
      headerName: "Item",
      sortable: false,
      flex: 1,
      minWidth: 200,
      filterable: false,
    },
    {
      field: "Item Description",
      headerName: "Item Description",
      sortable: false,
      flex: 1,
      minWidth: 400,
      filterable: false,
    },
    {
      field: "Actions",
      headerName: "Actions",
      sortable: false,
      flex: 1,
      minWidth: 200,
      filterable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <img src="/images/eye.svg"></img>
        </Box>
      ),
    },
  ];

  return (
    <>
      <FormCard
        title="Fire Department"
        fields={[
          { label: "Fire Department Name", type: "select" },
          { label: "Station", type: "select" },
          { label: "Engine Bay", type: "select" },
        ]}
        buttonText="Search Item"
        selectOptions={selectOptions}
      />
      <Card className="shadow p-3 " style={{ marginTop: "1rem" }}>
        <Grid className="d-flex justify-content-between mb-4">
          <Typography variant="h5" fontWeight={700}>
            Item List
          </Typography>
          <img src="/images/printer.svg"></img>
        </Grid>
        <MyTable
          rows={rows || []}
          columns={columns}
          checkboxSelection={false}
          // loading={tableLoading}
          hideFooter={true}
          className="mt-4"
        />
      </Card>
    </>
  );
};

export default FireDepartment;
